var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "alt": "Anima logo",
      "src": require("../assets/logo.png")
    }
  }), _c('h3', [_vm._v("Anima Admin")]), _vm.showNormalLogin ? _c('div', [_c('form', {
    staticClass: "container login",
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.login.apply(null, arguments);
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    model: {
      value: _vm.username,
      callback: function ($$v) {
        _vm.username = $$v;
      },
      expression: "username"
    }
  }), _c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "show-password": ""
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.auth || _vm.loading.admin,
      expression: "loading.auth || loading.admin"
    }],
    attrs: {
      "native-type": "submit",
      "type": "primary"
    }
  }, [_vm._v("Login")])], 1), _c('el-divider', [_vm._v(" Or ")])], 1) : _vm._e(), _c('GoogleButton', {
    on: {
      "click": _vm.onGoogleLoginClick,
      "success": _vm.onGoogleLoginSuccess,
      "failure": _vm.onGoogleLoginFailure
    }
  }, [_vm._v(" Log in with Google ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }